<template>
    <div>
        <div v-if="cart" class="mobile-cart">
            <div v-for="(album, c) in cart.albums" :key="c">
                <div v-for="(product, p) in album.products" :key="p" class="mobile-cart-product">
                    <template v-if="product">
                        <div class="mobile-cart-product-img" v-if="product.thumb_image" :style="`background-image: url(${product.thumb_image})`"></div>
                        <div v-else class="mobile-cart-product-no-img"></div>
                        <div class="mobile-cart-product-info">
                            <div class="mobile-cart-product-action">
                                <a href="#" class="btn btn-light btn-icon-left btn-shadow text-uppercase" @click.prevent="$store.dispatch('SET_MOBILE_CART_MENU', {album, product, index: p, parentIndex: c})">
                                    <span class="material-icon icon-create"/>
                                    {{ $t('edit') }}
                                </a>
                            </div>
                            <div class="mobile-cart-product-info-header">
                                <div class="mobile-cart-product-title">{{ product.name }}</div>
                                <div class="mobile-cart-product-price">{{ product.price | currency }}</div>
                            </div>
                            <div class="mobile-cart-product-description">
                                <template v-if="product.photos_quantity">{{ $tc('n_photos_2', product.photos_quantity, {amount_total_photos: product.photos_quantity}) }}</template><template v-if="product.products">{{ $tc('n_products', product.products.length, {amount: product.products.length}) }}</template><template v-if="product.snippet">, {{ product.snippet }}</template><template v-if="product.product_variant_name">, {{ product.product_variant_name }}</template>
                            </div>
                            <counter v-if="product.slug !== 'digital'" :index="p" :parent-index="c" :quantity="product.quantity"
                                     action="SET_PRODUCT_QUANTITY"/>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div v-else class="alert alert-info">{{ $t('shopping_cart.empty_card') }}</div>
    </div>
</template>

<style lang="scss">
    body[page="cart"] {

        #main + .mobile-menu:not(.mobile-menu--lang-switcher) {
            pointer-events: none;
            background-color: transparent;

            .mobile-menu {

                &__container {
                    pointer-events: auto;

                    & + .mobile-menu__actions {
                        display: flex;
                        pointer-events: auto;
                    }
                }

                &__btn {
                    bottom: 100px;
                    pointer-events: auto;

                    &.-bottom {
                        bottom: 20px;
                    }

                    &.-red {
                        bottom: 20px;
                    }
                }

                &__actions {
                    display: none;
                }
            }
        }
    }

    .mobile-cart {

        > div {

            &:last-child {

                .mobile-cart-product:last-child {
                    margin-bottom: 0;
                }
            }
        }

        &-product {
            margin-bottom: 20px;

            &-no-img,
            &-img {
                padding-top: 50%;
                background: 50% 50% no-repeat;
                background-size: cover;
            }

            &-no-img {
                background-image: url('../assets/no-preview-large.jpg');
            }

            &-info {
                position: relative;
                padding: 40px 20px 20px;
                background-color: var(--bg-color);

                &-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-end;
                }
            }

            &-action {
                position: absolute;
                display: flex;
                justify-content: center;
                width: 100%;
                left: 0;
                top: -18px;
            }

            &-title {
                font-size: 1rem;
            }

            &-description {
                color: var(--text-secondary-color);
                font-size: .87rem;
            }

            &-price {
                font-size: 1.25rem;
            }

            .counter {
                width: 130px;
                margin: 20px auto 0;

                .btn {
                    padding-top: 0 !important;
                    padding-bottom: 0 !important;
                }

                input {
                    height: 45px !important;
                }
            }
        }
    }
</style>

<script>
  import Counter from './Counter.vue';

  import cart from 'src/mixins/cartComponent';

  export default {
    mixins: [cart],
    components: {
      Counter,
    },
  };
</script>
